"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _faCircleNotch = require("@fortawesome/fontawesome-free-solid/faCircleNotch");

var _faCircleNotch2 = _interopRequireDefault(_faCircleNotch);

var _faSave = require("@fortawesome/fontawesome-free-solid/faSave");

var _faSave2 = _interopRequireDefault(_faSave);

var _button = require("./button");

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SubmitButton = function SubmitButton(_ref) {
    var icon = _ref.icon,
        submitting = _ref.submitting,
        submittingIcon = _ref.submittingIcon,
        props = _objectWithoutProperties(_ref, ["icon", "submitting", "submittingIcon"]);

    return _react2.default.createElement(
        _button2.default,
        _extends({ disabled: submitting }, props),
        submitting ? submittingIcon : icon ? icon : "",
        " ",
        props.label
    );
};

SubmitButton.displayName = "SubmitButton";

SubmitButton.propTypes = {
    submitting: _propTypes2.default.bool,
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
    /** The Icon to use whilst NOT submitting - probably a Font Awesome icon like   <FAIcon icon={faCircleNotch} spin />
     * If none is supplied no icon will display
     */
    icon: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
    /** The Icon to use whilst submitting - probably a Font Awesome icon like  <FAIcon icon={faCircleNotch} spin /> */
    submittingIcon: _propTypes2.default.object
};

SubmitButton.defaultProps = {
    submitting: false,
    icon: false,
    submittingIcon: _react2.default.createElement(_reactFontawesome2.default, { icon: _faCircleNotch2.default, spin: true })
};

exports.default = SubmitButton;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/buttonSubmit.js
// module id = 449
// module chunks = 95715928098905 168707334958949